export default __webpack_public_path__ + "62df1bd57d3ac9345a4609ec7be41b38.wav";